import React from 'react';
import '../styles/Pages.css';

const PrivacyPage = () => (
  <div className="page-container">
    <div className="page-content">
      <h2>Privacy Policy</h2>
      <p className="event-description" style={{ marginBottom: '1.5rem' }}>
        Last updated: June 22, 2026
      </p>

      <div className="info-section">
        <h3>Overview</h3>
        <p className="event-description">
          CanAm Games is a private, invitation-only tool used to organize a personal backyard
          event. It is not a commercial service. This policy explains what information we collect
          from invited guests and how we use it.
        </p>
      </div>

      <div className="info-section">
        <h3>Information We Collect</h3>
        <ul className="event-highlights">
          <li>Your name (to match you to the guest list)</li>
          <li>Your email address (optional)</li>
          <li>Your mobile phone number (optional, for event text updates)</li>
          <li>Your RSVP details (attendance, team, what you're bringing, and any notes you provide)</li>
        </ul>
      </div>

      <div className="info-section">
        <h3>How We Use Your Information</h3>
        <ul className="event-highlights">
          <li>To send event invitations, RSVP confirmations, reminders, and updates</li>
          <li>To coordinate attendance and what guests are bringing</li>
          <li>To contact you about the event if needed</li>
        </ul>
      </div>

      <div className="info-section">
        <h3>Text Messaging (SMS)</h3>
        <p className="event-description">
          If you provide your mobile number, you may receive text messages about the event
          (invitations, confirmations, reminders, and updates). Message frequency varies. Message
          and data rates may apply. You can opt out at any time by replying <strong>STOP</strong>,
          and reply <strong>HELP</strong> for help.
        </p>
        <p className="event-description" style={{ marginTop: '1rem' }}>
          <strong>We do not sell or share your information — including your phone number — with any
          third parties.</strong> Mobile opt-in information is never shared with third parties or
          affiliates for marketing or promotional purposes. Phone numbers are used solely to send
          you messages about this event.
        </p>
      </div>

      <div className="info-section">
        <h3>Data Security &amp; Retention</h3>
        <p className="event-description">
          Your information is stored privately and is accessible only to the event host. It is used
          only for this event and is not used for any other purpose.
        </p>
      </div>

      <div className="info-section">
        <h3>Contact</h3>
        <p className="event-description">
          Questions about this policy? Contact the host at{' '}
          <a href="mailto:alexfinley137@gmail.com">alexfinley137@gmail.com</a> or
          (716) 908-0639.
        </p>
      </div>
    </div>
  </div>
);

export default PrivacyPage;
